const isReactNative = () =>
  typeof navigator !== 'undefined' &&
  typeof navigator.product === 'string' &&
  navigator.product.toLowerCase() === 'reactnative'

export default isReactNative
